import type { ProductionEntry } from "./models";
import { normalizedProductionUnit } from "./quantity-unit-options";

export function groupedScrapQuantities(entries: ProductionEntry[]) {
  const groups = new Map<string, { unit: string; quantity: number }>();
  for (const entry of entries) {
    if (entry.voidedAt || entry.type === "PRODUCTION") continue;
    if (!Number.isFinite(entry.quantity) || entry.quantity < 0 || !entry.unit.trim()) return null;
    const key = normalizedProductionUnit(entry.unit);
    const group = groups.get(key) ?? { unit: entry.unit, quantity: 0 };
    group.quantity += entry.quantity;
    groups.set(key, group);
  }
  return [...groups.values()];
}
